<template>
  <div class="button-container">
    <button @click.prevent="buttonAction()"
            class="schedule-button">
      <i class="schedule-icon"
         :class="{'fas fa-lock-open-alt' : !locked,
                  'fas fa-lock-alt' : locked}"/>
    </button>
  </div>
</template>

<script>
export default {
  props: ['teamID'],
  computed: {
    locked: function () {
      return this.$store.getters.getJudgingTeamLockStatus(this.teamID)
    }
  },
  methods: {
    buttonAction: function () {
      this.$store.dispatch('setJudgingTeamLockStatus', { teamID: this.teamID })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
.button-container {
  width: 100%;
  z-index: 20;
  button {
    border: none;
    float: right;
    background-color: transparent;
    z-index: 20;
    @include mobile {
      position: relative;
    }
  }
  .schedule-button {
    color: #89CFF0;
    z-index: 20;
    cursor: pointer;
    transition: font-size 0.2s;
    transition: color 0.5s;
    &:hover .schedule-icon{
     color: #87CEEB;
    }
     i {
       font-size: 1.4em;
     }
  }

}
</style>
